import React from 'react'
import Dialog from 'material-ui/Dialog'
import { Button } from '@sketchpixy/rubix'

const TopStudentsOfEventModal = ({ isOpen, onClose, data = [{ stats: [] }] }) => {
  const props = {
    title: 'لیست نتایج',
    onRequestClose: onClose,
    open: isOpen,
    actions: [
      <Button bsStyle="primary" onClick={onClose}>
        بستن
      </Button>
    ],
    modal: false,
    autoScrollBodyContent: true,
    actionsContainerClassName: 'modal-actions',
    contentClassName: 'fatemi-modal'
  }

  return (
    <Dialog {...props}>
      <table className="top-students-by-state">
        <thead>
          <tr>
            <th> </th>

            {data[0].stats.map(({ grade }) => (
              <th key={grade}>{grade}</th>
            ))}
          </tr>
        </thead>

        <tbody>
          {data.map((statRow, index) => (
            <tr key={index}>
              <td>{statRow.state}</td>

              {statRow.stats.map(({ count }, index) => (
                <td key={`${statRow.state}-${index}`}>
                  {Intl.NumberFormat('fa-IR').format(count)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </Dialog>
  )
}

export default TopStudentsOfEventModal


// WEBPACK FOOTER //
// ./src/components/common/events/TopStudentsOfEventModal.js